export const CONTENT_DISPOSITION = { 'Content-Disposition': 'attachment' }
